var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
import { useSuggestedSpaceQueryBase } from './useSuggestedSpaceQueryBase';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { useCreateEventContext } from '../composers/CreateEventContext';
import { useMemo } from 'react';
var GET_SUGGESTED_SPACES_FOR_TIME_FRAME = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query EventComposerGetSuggestedSpacesForTimeFrame(\n    $input: GetSuggestedSpacesForTimeFrameInput!\n  ) {\n    getSuggestedSpacesForTimeFrame(input: $input) {\n      suggestedSpaces {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query EventComposerGetSuggestedSpacesForTimeFrame(\n    $input: GetSuggestedSpacesForTimeFrameInput!\n  ) {\n    getSuggestedSpacesForTimeFrame(input: $input) {\n      suggestedSpaces {\n        id\n        name\n      }\n    }\n  }\n"])));
export function useCreateEventSuggestedSpaceQuery(_a) {
    var _b;
    var levelId = _a.levelId, totalInviteesWithUserId = _a.totalInviteesWithUserId;
    var _c = useEventComposerGlobalContext(), suggestedSpacesEnabled = _c.suggestedSpacesEnabled, locationId = _c.locationId;
    var initialEvent = useCreateEventContext().initialEvent;
    var _d = useSuggestedSpaceQueryBase({
        enabled: !!suggestedSpacesEnabled && !!locationId,
        locationId: locationId,
        levelId: levelId,
    }), debouncedRange = _d.debouncedRange, levelIdsForPreferences = _d.levelIdsForPreferences, preferredSpaceCapacity = _d.preferredSpaceCapacity, commonSkipReasons = _d.commonSkipReasons;
    var variables = commonSkipReasons || !locationId
        ? undefined
        : {
            input: {
                algorithm: null,
                startTime: debouncedRange.start,
                endTime: debouncedRange.end,
                filters: {
                    locationIds: [locationId],
                },
                spacePreferences: {
                    levelIds: levelIdsForPreferences,
                    preferredSpaceCapacity: preferredSpaceCapacity,
                },
            },
        };
    var _e = useQuery(GET_SUGGESTED_SPACES_FOR_TIME_FRAME, {
        skip: commonSkipReasons || totalInviteesWithUserId < 2,
        variables: variables,
        fetchPolicy: 'cache-and-network',
    }), data = _e.data, loading = _e.loading;
    /* Get a random suggested space not in the initial spaces Id list */
    var randomSuggestedSpace = useMemo(function () {
        var _a, _b;
        var suggestedSpaces = (_b = (_a = data === null || data === void 0 ? void 0 : data.getSuggestedSpacesForTimeFrame) === null || _a === void 0 ? void 0 : _a.suggestedSpaces) === null || _b === void 0 ? void 0 : _b.filter(function (space) { var _a; return !((_a = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaceIds) === null || _a === void 0 ? void 0 : _a.includes(space.id)); });
        return suggestedSpaces === null || suggestedSpaces === void 0 ? void 0 : suggestedSpaces[Math.floor(Math.random() * suggestedSpaces.length)];
    }, [data, initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaceIds]);
    return {
        suggestedSpaceId: (_b = randomSuggestedSpace === null || randomSuggestedSpace === void 0 ? void 0 : randomSuggestedSpace.id) !== null && _b !== void 0 ? _b : null,
        loading: loading,
    };
}
var templateObject_1;
